import React, {Component} from "react";
import CommissioningTool from "../CommissioningTool";
import "bootstrap/dist/css/bootstrap.min.css";
import CommToolContext from "../../containers/common/comm_tool_context";
import {withRouter} from "react-router-dom";
import {Modal} from "antd";
import {userHasRoles} from "../../utils/UserInfo";

let mockNotifications = [
  {
    title: "Dublin – Station Upgrade 2018",
    desc:
        "Please match the IPS Locations to outages to create energization groups.",
    action: "Go to project"
  },
  {
    title: "Dublin - Station Upgrade 2018",
    desc: "Please add team members to the project.",
    action: "Go to team"
  },
  {
    title: "Canal Winchester - Station Upgrade 2018",
    desc:
        "Please match the IPS Locations to outages to create energization groups, and set up the correct assets.",
    action: "Go to project"
  }
];
class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openTab: this.props.openTab,
      showRoleWarning: false
    }
  }

  showNoRoleWarning = () => {
    Modal.warning({
      title: "Missing RoleView...",
      content: (
          <p>The User Account that is currently logged in has not been assigned any roles. Please Contact IT to Fix this Issue.</p>
      ),
      centered: true
    })
  };

  render() {
    return (
      <CommToolContext.Consumer>
        {context => (
          <React.Fragment>
            <CommissioningTool {...this.props}/>
          </React.Fragment>
        )}
      </CommToolContext.Consumer>
    );
  }
}
Layout.contextType = CommToolContext;
export default withRouter(Layout);
